<template>
  <base-table-component
    :title="title"
    :description="description"
    :rows="effectiveRows"
    :columns="columns"
    :summary-row="summaryRow"
  />
</template>

<script lang="ts">
import { Options, mixins } from 'vue-class-component'
import { ITableColumn, TableUtils } from '@/utils/table'
import TableMixin, { ColumnName } from './mixins/TableMixin.vue'
import BaseTableComponent from './components/BaseTableComponent.vue'
import { MESSAGE_TYPE } from '@/utils/constants'

@Options({
  name: 'FormTable',
  components: {
    BaseTableComponent,
  },
})
export default class FormTable extends mixins(TableMixin) {
  protected getDefaultMessageType(): string {
    return MESSAGE_TYPE.FORM
  }

  get columns(): ITableColumn[] {
    return [
      ...this.baseColumns,
      {
        name: 'delivered',
        label: this.$t('label.delivery_count'),
        field: 'delivered',
        align: 'right',
        format: TableUtils.formatNumber,
      },
      {
        name: 'total_click',
        label: this.$t('label.clicks'),
        field: 'total_click',
        align: 'right',
        format: TableUtils.formatNumber,
      },
      {
        name: 'anwser_rate',
        label: this.$t('label.anwser_rate'),
        align: 'right',
        field: (row: any) => TableUtils.calculatePercent(row.total_user_of_goal, row.delivered),
        format: TableUtils.formatPercent,
      },
      {
        name: 'total_user_of_goal',
        label: this.$t('label.anwser_count'),
        field: 'total_user_of_goal',
        align: 'right',
        format: TableUtils.formatNumber,
      },
      ...this.getCommonColumns([ColumnName.CVR, ColumnName.TARGET]),
    ]
  }

  protected calculateSummary(): Record<string, number> {
    const summary = (TableMixin.prototype as any).calculateSummary.call(this)

    summary.anwser_rate = TableUtils.calculatePercent(summary.total_user_of_goal, summary.delivered)

    return summary
  }
}
</script>
